var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.logout}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("mdi-logout")])],1),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"body-2"},[_vm._v("Sign Out")]),_c('v-list-item-subtitle',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$auth.user().email))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }